// extracted by mini-css-extract-plugin
module.exports = {"link-add-voucher":"LinkAddVoucher_link-add-voucher__2k8ed","link":"LinkAddVoucher_link__i_XZL"};